import { render, staticRenderFns } from "./NewsCenterDetails4.vue?vue&type=template&id=111bedd5&scoped=true"
import script from "./NewsCenterDetails4.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails4.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails4.vue?vue&type=style&index=0&id=111bedd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111bedd5",
  null
  
)

export default component.exports